
const devConf = {
  baseServerUrl: 'http://localhost:3000',
  // baseApiUrl: 'http://localhost:3000/api'
}

module.exports = devConf